import { ApiStatuses } from '../../../../global/models/api-model';
import { DemographicAppKeys } from '../../../../global/models/demographics-model';

export enum GenericDocumentUpload {
    MemberDocUpload = 'MemberDocUpload',
    AdminDocUpload = 'AdminDocUpload',
}

export interface DocumentUploadState {
    showDocumentUpload: boolean,
    documentUploaded: boolean,
    documentsUploadedCount: number,
    hideToast?: boolean,
    stagedDocuments: File[],
    uploadStatus?: ApiStatuses,
    showInternationalWarning: boolean,
    showDemographicWarning: boolean,
    isReceivingPensionOrPayout?: boolean,
}

export interface DocumentUploadAppState {
    [DemographicAppKeys.myCPG]: DocumentUploadState;
    [DemographicAppKeys.arc]: DocumentUploadState;
    [GenericDocumentUpload.MemberDocUpload]: DocumentUploadState,
    [GenericDocumentUpload.AdminDocUpload]: DocumentUploadState,
}

export enum DocumentUploadActionTypes {
    TOGGLE_DOCUMENT_UPLOAD = 'TOGGLE_DOCUMENT_UPLOAD',
    UPDATE_DOCUMENT_UPLOAD_STATUS = 'UPDATE_DOCUMENT_UPLOAD_STATUS',
    STAGE_DOCUMENTS = 'STAGE_DOCUMENTS',
    RESET_DOC_STATE = 'RESET_DOC_STATE',
    SET_TOAST_HIDE = 'SET_TOAST_HIDE',
    SET_UPLOAD_STATUS = 'SET_UPLOAD_STATUS',
    SET_RECEIVING_PENSION_PAYOUT = 'SET_RECEIVING_PENSION_PAYOUT',
}
